<template>
  <div>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.key" placeholder="输入用户名/姓名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="userData" highlight-current-row @current-change="handleCurrentChange" v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="50">
      </el-table-column>
      <el-table-column align="center" prop="uname" label="用户名">
      </el-table-column>
      <el-table-column align="center" prop="realname" label="姓名">
      </el-table-column>
      <el-table-column align="center" prop="is_lock" label="状态">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.is_lock" active-color="#13ce66" inactive-color="#ff4949"
          active-value="1" inactive-value="0" disabled>
          </el-switch>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <div style="text-align: right;margin-top: 30px;">
      <el-button @click="closed">取 消</el-button>
      <el-button type="primary" @click="submit_data">确 定</el-button>
    </div>
  </div>
</template>

<script>
  import { userList } from '../api/baseset.js'
  import Pagination from './Pagination.vue'
  export default {
    name: 'changeuser',
    props: ['utype'],
    data() {
      return {
        loading: false, //是显示加载
        // 请求数据参数
        formInline: {
          page: 1,
          limit: 10,
          key: ''
        },
        //用户数据
        userData: [],
        currentRow: {},
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    created() {
      this.getdata(this.formInline)
    },
    methods: {
      // 获取数据方法
      getdata(parameter) {
        this.loading = true
        parameter.utype = this.utype?1:0
         userList(parameter).then(res => {
           this.loading = false
           if (res.code != 0) {
             this.$message({
               type: 'info',
               message: res.msg
             })
           } else {
             this.userData = res.data
             // 分页赋值
             this.pageparm.currentPage = this.formInline.page
             this.pageparm.pageSize = this.formInline.limit
             this.pageparm.total = res.count
           }
         })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      //搜索事件
      search() {
        this.formInline.page = 1
        this.formInline.limit = 10
        this.getdata(this.formInline)
      },
      handleCurrentChange(val) {
        this.currentRow = val
      },
      closed() {
        this.$emit('close_changeuser')
      },
      submit_data() {
        if(this.currentRow.id == undefined) {
          this.$message.error('请选择用户')
          return
        }
        this.$emit('changeuser',this.currentRow)
        this.closed()
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/changeuser.vue